import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store/store';

export const PINCODE_SLICE_NAME = 'pincode';

export interface PincodeState {
  pincode: string | null;
  sid: string | null;
  isConfirmed: boolean;
}

const initialState: PincodeState = {
  pincode: null,
  sid: null,
  isConfirmed: false,
};

export const pincodeSlice = createSlice({
  name: PINCODE_SLICE_NAME,
  initialState,
  reducers: {
    setPincodeState(
      state,
      action: PayloadAction<{ pincode: string; sid?: string | null; isConfirmed?: boolean }>
    ) {
      state.pincode = action.payload.pincode;
      state.sid = action.payload.sid ?? null;
      state.isConfirmed = action.payload.isConfirmed ?? true;
    },
    clearPincodeState(state) {
      state.pincode = null;
      state.sid = null;
      state.isConfirmed = false;
    },
  },
});

export const { setPincodeState, clearPincodeState } = pincodeSlice.actions;

export const selectPincode = (state: RootState) => state[PINCODE_SLICE_NAME]?.pincode ?? null;
export const selectPincodeSid = (state: RootState) => state[PINCODE_SLICE_NAME]?.sid ?? null;
export const selectIsPincodeConfirmed = (state: RootState) =>
  state[PINCODE_SLICE_NAME]?.isConfirmed ?? false;

export default pincodeSlice.reducer;
